module.exports = {"Type":"CallQnA","Disabled":false,"Output":true,"Fields":[],"Header":{"Color":"white","BackgroundColor":"orange","Text":""}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/CallQnA.json
// module id = 685
// module chunks = 0